"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AddToBasket = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const AddToBasket = exports.AddToBasket = (0, _mui.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15.34 5.553a4.17 4.17 0 00-4.165-4.165 4.17 4.17 0 00-4.164 4.165v1.388h8.33V5.553z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M21.029 8.948C20.917 7.84 19.922 6.94 18.81 6.94h-2.083V5.553A5.56 5.56 0 0011.175 0a5.56 5.56 0 00-5.553 5.553v1.388H3.54c-1.112 0-2.107.9-2.218 2.007L.21 20.068a1.934 1.934 0 001.942 2.144h11.493a6 6 0 017.804-9.063l-.42-4.201zM15.34 6.94H7.01V5.553a4.17 4.17 0 014.165-4.165 4.17 4.17 0 014.165 4.165v1.388z",
      fill: "currentColor",
      fillRule: "nonzero"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M20.765 17.45h-2.297v-2.297a.55.55 0 00-1.1 0v2.297H15.07a.55.55 0 000 1.1h2.297v2.297a.55.55 0 001.1 0V18.55h2.298a.55.55 0 000-1.1z",
      fill: "currentColor",
      fillRule: "nonzero"
    })]
  })
}), 'AddToBasket');
var _default = exports.default = AddToBasket;